import { create } from 'zustand';

/**
 * Open state for the "?" keyboard-shortcut cheatsheet. A store rather than
 * local state so any surface (the sidebar's Help footer, a help menu) can open
 * the same dialog without prop-drilling through the shell.
 */
interface KeyboardShortcutsState {
  isOpen: boolean;
  openShortcuts: () => void;
  closeShortcuts: () => void;
  setShortcutsOpen: (isOpen: boolean) => void;
}

export const useKeyboardShortcutsStore = create<KeyboardShortcutsState>(set => ({
  isOpen: false,
  openShortcuts: () => set({ isOpen: true }),
  closeShortcuts: () => set({ isOpen: false }),
  setShortcutsOpen: isOpen => set({ isOpen }),
}));
